// src/data/ProductsData.js
const ProductsData = [
    { 
      id: 1, 
      name: "AI Chatbot API", 
      category: "APIs", 
      seller: "TechAI Labs", 
      price: 99, 
      description: "A powerful AI chatbot API designed for seamless integration into websites, apps, and customer service platforms.", 
      rating: 4.5,
      imageUrl: "https://c.mql5.com/31/1290/gold-scalping-ai-mt5-logo-200x200-3906.png"
    },
    { 
      id: 2, 
      name: "Fraud Detection Model", 
      category: "AI Models", 
      seller: "SecureAI", 
      price: 199, 
      description: "An advanced AI model for detecting fraudulent transactions in real-time.", 
      rating: 4.8,
      imageUrl: "https://via.placeholder.com/150?text=Fraud+Detection+Model"
    },
    { 
      id: 3, 
      name: "Medical Diagnosis AI", 
      category: "AI Software", 
      seller: "MediTech", 
      price: 299, 
      description: "AI-powered software for medical diagnosis, leveraging deep learning to assist doctors.", 
      rating: 4.7,
      imageUrl: "https://via.placeholder.com/150?text=Medical+Diagnosis+AI"
    },
    { 
      id: 4, 
      name: "Speech Recognition Dataset", 
      category: "Datasets", 
      seller: "DataX", 
      price: 49, 
      description: "A high-quality dataset for training speech recognition models.", 
      rating: 4.3,
      imageUrl: "https://via.placeholder.com/150?text=Speech+Recognition+Dataset"
    },
  ];
  
  export default ProductsData;